<div class="modal-header py-2">
  <h2 class="my-2"><b>Type password</b></h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn" (click)="close()"></tr-icon>
</div>
<div class="modal-body">
  <p>To confirm the email or username change, enter the current password</p>

  <form [formGroup]="form" novalidate role="form" autocomplete=“off”>
    <div class="form-group">
      <input
        type="password"
        class="form-control"
        id="password"
        name="newPassword"
        placeholder="Enter password"
        autocomplete="new-password"
        formControlName="password"
        [class.is-invalid]="form.get('password').invalid && form.get('password').touched" />
      <control-messages [control]="form.get('password')"></control-messages>
    </div>

    <div class="row">
      <div class="form-group col">
        <button class="btn btn-info w-100" type="submit" (click)="confirm()" [disabled]="form.pristine || !form.valid">Save</button>
      </div>

      <div class=" form-group col">
        <button type="button" class="btn btn-danger w-100" (click)="close()">Cancel</button>
      </div>
    </div>
  </form>
</div>
